"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGenderFemale(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    width: 11,
    height: 20
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)",
    stroke: "#E568B2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.198 12.083L3.95 6.614a1 1 0 01.894-.55h1.28a1 1 0 01.89.545l2.803 5.483a1 1 0 01-.89 1.455H8.14a1 1 0 00-1 1v2.77a1 1 0 01-1 1H4.972a1 1 0 01-1-1v-2.793a1 1 0 00-1.009-1l-.863.008a1 1 0 01-.902-1.45z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.614,
    cy: 2.159,
    r: 2.159
  })));
}

var MemoSvgGenderFemale = /*#__PURE__*/React.memo(SvgGenderFemale);
var _default = MemoSvgGenderFemale;
exports["default"] = _default;